import { useEffect, useMemo, useState } from "react";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { FerramentasDaListagem, FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { VForm, useVForm } from "../../shered/forms";
import { Box, Tab, Tabs, Paper, Typography, useTheme, Tooltip} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { DataGrid, GridColDef, GridColumnHeaderParams } from "@mui/x-data-grid";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { IDetalheJogadorFreeAgency, JogadorService } from "../../shered/services/api/jogador/JogadorService";
import { ILstDrop, TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { DisputaService, IDadosClassificacao } from "../../shered/services/api/disputa/DisputaService";
import {
    EstatisticasService,
    IDadosClassificacaoTrofeusLiga,
    IDadosHistoricoTrofeusLiga,
    IDadosTitulosDivisao,
    IDadosTrofeusLigaDetalhes,
    IDadosTrofeusLigaFranquias,
    IFranquiaTituloDetalhesConferencia,
    IListaDadosObjetoTrofeusLiga,
    ITitulosResumidoConferencia
} from "../../shered/services/api/estatisticas/EstatisticasService";
import { ptBR } from '@mui/x-data-grid/locales';
let temporadaAtual = 0;
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                <Box sx={{ p: 1 }}>
                    <Grid container>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}




export const ListagemDeTrofeusLiga: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const { themeName } = useAppThemeContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");    
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../../semimagemescudo.png");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [opcoesAutoCompleteUsuario, setOpcoesAutoCompleteUsuario] = useState<ILstDrop[]>([]);
    const [nomeLiga, setNomeLiga] = useState("");
    const [logoLiga, setLogoLiga] = useState("");
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [value, setValue] = useState(0);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [dadosTrofeusLiga, setDadosTrofeusLiga] = useState<IListaDadosObjetoTrofeusLiga>();
    const [classificacaoLigaRows, setClassificacaoLigaRows] = useState<IDadosClassificacaoTrofeusLiga[]>([]);
    const [historicoLigaRows, setHistoricoLigaRows] = useState<IDadosHistoricoTrofeusLiga[]>([]);
    const [confrontosDetalhesConferencia, setConfrontosDetalhesConferencia] = useState<IFranquiaTituloDetalhesConferencia>();
    const [confrontosDetalhesDivisao, setConfrontosDetalhesDivisao] = useState<IDadosTitulosDivisao[]>([]);
    const [listaConferencia, setListaConferencia] = useState<ITitulosResumidoConferencia[]>([]);
    const [imagemTrofelConferencia, setImagemTrofelConferencia] = useState<any | null>("../../../newConferencia.png");
    const [imagemTrofelDivisao, setImagemTrofelDivisao] = useState<any | null>("../../../newDivisao.png");
    const [imagemTrofelCopinha, setImagemTrofelCopinha] = useState<any | null>("../../../newCopinha.png");
    const [imagemTrofelLiga, setImagemTrofelLiga] = useState<any | null>("../../../newLiga.png");
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteUsuario.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteUsuario]);

    const columnsGeral: GridColDef[] = [
        {
            field: 'posicao', headerName: '',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            maxWidth: 50,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'logo_Franquia',
            headerName: 'LOGO',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            maxWidth: 90,
            renderCell: (params) => params.value !== null ? <img src={params.value} width={45} height={50} />
                : <img
                    src={showImagemFranquia}
                    alt="semLogoFranquia"
                    width={UtilidadeService.isMobile() ? 25 : 45}
                    height={UtilidadeService.isMobile() ? 30 : 50}
                />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
        },
        {
            field: 'nome_Franquia',
            headerName: 'FRANQUIA',
            editable: false,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'quantidade_Titulo_Liga',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelLiga}
                    width={UtilidadeService.isMobile() ? 40 : 80}
                    height={UtilidadeService.isMobile() ? 25 : 45}
                    alt="lig"
                />
            ),
            //headerName: 'LIGA',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 90,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Titulo_Conferencia',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelConferencia}
                    width={UtilidadeService.isMobile() ? 25 : 50}
                    height={UtilidadeService.isMobile() ? 30 : 55}
                    alt="conf"
                />
            ),
            //headerName: 'CONFERÊNCIA',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 90,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Titulo_Divisao',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelDivisao}
                    width={UtilidadeService.isMobile() ? 55 : 85}
                    height={UtilidadeService.isMobile() ? 25 : 50}
                    alt="div"
                />
            ),
            //headerName: 'DIVISÃO',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 90,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'quantidade_Titulo_Copinha',
            renderHeader: (params: GridColumnHeaderParams) => (
                <img
                    src={imagemTrofelCopinha}
                    width={UtilidadeService.isMobile() ? 55 : 42}
                    height={UtilidadeService.isMobile() ? 25 : 48}
                    style={{paddingTop:"5px"}}
                    alt="div"
                />
            ),            
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 90,
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'foto_Usuario',
            headerName: 'FOTO',
            editable: false,
            sortable: UtilidadeService.isMobile() ? false : true,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            maxWidth: 90,
            align: 'center',
            headerAlign: 'center',
            headerClassName: 'super-app-theme--header',
            renderCell: (params) =>
                params.value !== null && params.value !== undefined
                    ? <img
                        src={params.value} alt="foto" width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 35 : 45} />
                    : <img src={semImagem} alt="Semfoto" width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 35 : 45} />,
        },
        {
            field: 'nome_Usuario',
            headerName: 'NOME',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 150,
            editable: true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },

        },
    ];   

    const columnsDetalhesConfronto: GridColDef[] = [
        {
            field: 'codigo_Temporada', headerName: '',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 35 : 40,
            maxWidth: 50,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            sortable: false,
        },
        {
            field: 'descricao_Temporada',
            headerName: 'TEMPORADA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            //   maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'logo',
            headerName: '',
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            maxWidth: 65,
            flex: 1,            
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) =>  <img alt="logo" src={params.value !== null ? params.value: showImagemFranquia} width={40} height={45} />
        },
        {
            field: 'nome',
            headerName: 'FRANQUIA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'nome_Conferencia',
            headerName: 'CONFERÊNCIA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'nome_Divisao',
            headerName: 'DIVISÃO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.value}
                    </Box>
                );
            },
        },
    ]
    
    const columnsHistorico: GridColDef[] = [
        {
            field: 'descricao_Temporada',
            headerName: 'TEMPORADA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 90 : 110,
            //   maxWidth: 40,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'logo_Franquia_Campea_Liga',
            headerName: '',
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            maxWidth: 65,
            flex: 1,
            renderCell: (params) => params.value !== null
                ? <img alt="logo" src={params.value} width={40} height={45} />
                : <img
                    src={showImagemFranquia}
                    alt="semLogo"
                    width={UtilidadeService.isMobile() ? 25 : 40}
                    height={UtilidadeService.isMobile() ? 30 : 45}
                />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'franquia_Campea_Liga',
            headerName: 'LIGA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.row.franquia_Campea_Liga != null ? params.row.franquia_Campea_Liga : ""}
                    </Box>
                );
            },
        },
        {
            field: 'logo_Franquia_Campea_Conferencia',
            headerName: '',
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            maxWidth: 65,
            flex: 1,
            renderCell: (params) => params.row.logo_Franquia_Campea_Conferencia !== null
                ? <img alt="logo" src={params.value} width={40} height={45} />
                : <img
                    src={showImagemFranquia}
                    alt="semLogo"
                    width={UtilidadeService.isMobile() ? 25 : 40}
                    height={UtilidadeService.isMobile() ? 30 : 45}
                />,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'franquia_Campea_Conferencia',
            headerName: 'CONFERÊNCIA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {

                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.row.franquia_Campea_Conferencia != null ? params.row.franquia_Campea_Conferencia : ""}
                    </Box>
                );
            },
        },
        {
            field: 'logo',
            headerName: 'DIVISÃO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 110 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                            display: "flex",
                            alignSelf: "center",
                        }}
                    >
                        {params.row.franquia_Campea_Divisao.length > 0
                            ?
                            params.row.franquia_Campea_Divisao.map((m: IDadosTrofeusLigaFranquias, i: number) => (
                                <span style={{ padding: "4px" }}>
                                    <Tooltip key={m.codigo} title={m.nome.toUpperCase()}>
                                        <img alt={i.toString()} src={m.caminho_Logo === null ? showImagemFranquia : m.caminho_Logo} width={40} height={45} />
                                    </Tooltip>
                                </span>

                            )) : <img
                                src={showImagemFranquia}
                                alt="semLogo"
                                width={UtilidadeService.isMobile() ? 25 : 40}
                                height={UtilidadeService.isMobile() ? 30 : 45}
                            />}
                    </Box>
                );
            },
        },
         {
            field: 'logo_Franquia_Campea_Copinha',
            headerName: '',
            minWidth: UtilidadeService.isMobile() ? 35 : 65,
            maxWidth: 65,
            flex: 1,
            renderCell: (params) => params.value !== null && params.value !== undefined
                ? <img alt="logo" src={params.value} width={40} height={45} />
                : ""
                // <img
                //     src={showImagemFranquia}
                //     alt="semLogo"
                //     width={UtilidadeService.isMobile() ? 25 : 40}
                //     height={UtilidadeService.isMobile() ? 30 : 45}
                // />
                ,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'franquia_Campea_Copinha',
            headerName: 'COPINHA',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 85 : 250,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {params.row.franquia_Campea_Copinha != null ? params.row.franquia_Campea_Copinha : ""}
                    </Box>
                );
            },
        },
    ];


    useEffect(() => {
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        setIsLoading(true);
        const fetchData = async () => {

            await EstatisticasService.getTrofeusLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setDadosTrofeusLiga(liga);
                    setClassificacaoLigaRows(liga.classificacao_Geral);
                    let dadosDrop = liga.classificacao_Geral.length > 0 ? liga.classificacao_Geral.map(p => ({ codigo: p.codigo_Usuario, label: p.nome_Usuario })) : [];
                    setOpcoesAutoCompleteUsuario(dadosDrop);               
                    setHistoricoLigaRows(liga.historico);
                    setConfrontosDetalhesConferencia(liga.detalhes.detalhes_Conferencia);
                    setListaConferencia(liga.detalhes.detalhes_Conferencia.titulos_Conferencia);
                    setConfrontosDetalhesDivisao(liga.detalhes.detalhes_Divisao);                    
                    setNomeLiga(liga.nome);
                    setLogoLiga(liga.caminho_Logo);

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response != undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    else {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados dos troféus da liga.  Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                    }
                });
        }
        fetchData();
        setRemoveLoading(true);

    }, [codigoLiga]);

    const handleSave = async (dados: any) => {
    }

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            //     .then((result) => {
            //         setShowModalMensagem(true);
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "success",
            //             mensagem: "Registro excluido com sucesso!",
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //         setRedirecionar("/franquias");
            //     })
            //     .catch((errors) => {
            //         setShowModalMensagem(true);
            //         if (errors.response.data.statusHTTP === 401) {
            //             logout();
            //             setDadosModalMensagem({
            //                 acao: true,
            //                 label: "",
            //                 tipo: "error",
            //                 mensagem: "Sessão expirada!",
            //                 display: "none",
            //                 titulo: "Atenção"
            //             });
            //             setRedirecionar("0");;
            //             return;
            //         }
            //         setDadosModalMensagem({
            //             acao: true,
            //             label: "",
            //             tipo: "error",
            //             mensagem: errors.response.data.mensagem,
            //             display: "none",
            //             titulo: "Atenção"
            //         });
            //     });
        }
    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "0");
    }, [searchParams]);


    return (

        <LayoutBaseDePagina
            titulo={`Sala de Troféus - ${nomeLiga}`}
            showLogoImg={logoLiga}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">

                <Grid container size={{xs:12, sm:12}} direction="column" padding={2} spacing={2}>
                    <Grid  size={{xs:12, sm:12}} alignItems="center" justifyContent="center" width="100%">
                        <Paper>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChangeTabs} centered variant="fullWidth">
                                    <Tab label="CLASSIFICAÇÃO" {...a11yProps(0)} />
                                    <Tab label="HISTÓRICO" {...a11yProps(1)} />
                                    <Tab label="CONFRONTOS"  {...a11yProps(2)} />
                                </Tabs>
                            </Box>
                            <TabPanel value={value} index={0} >                               
                                {!removeLoading && <Loading />}
                                <Grid container size={{xs:12, sm:12}} spacing={1} display="flex" padding={0}>
                                    <Grid container size={{xs:12, sm:12}} textAlign="initial" >                                       
                                        <Grid  size={{xs:12, sm:12}} style={{ width: "100%" }}>
                                            <Grid  size={{xs:12, sm:12}}>
                                                {isLoading && !removeLoading && <Loading />}
                                            </Grid>
                                            <Grid  size={{xs:12, sm:12}}  >
                                                {classificacaoLigaRows.length > 0 && (
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white,
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            fontWeight: '600',
                                                        },
                                                        '& .super-app-theme--cell': {
                                                            color: '#00e676',
                                                            fontWeight: '600',
                                                        },
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(r) => r.posicao}
                                                            rows={classificacaoLigaRows}
                                                            columns={columnsGeral}
                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 16,
                                                                    },
                                                                },
                                                            }}
                                                            columnVisibilityModel={{
                                                                codigo: false,
                                                            }}
                                                            pageSizeOptions={[16, 25, 50, 100]}
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 12 : 16,
                                                            }}

                                                        />
                                                    </Box>
                                                )}
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                </Grid>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <Grid container size={{xs:12, sm:12}}>
                                    <Grid container marginTop={1} size={{xs:12, sm:12}}>
                                        {!removeLoading && <Loading />}
                                        <Grid container size={{xs:12, sm:12}} padding={1}>
                                            {historicoLigaRows.length > 0 ? (
                                                <Grid  size={{xs:12, sm:12}}>
                                                    <Box sx={{
                                                        height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                        '& .super-app-theme--header': {
                                                            backgroundColor: theme.palette.common.black,
                                                            color: theme.palette.common.white
                                                        },
                                                        '& .super-app.negative': {
                                                            color: 'red',
                                                            fontWeight: 'bold'
                                                        },
                                                        '& .super-app.positive': {
                                                            color: themeName === "light" ? "black" : "auto",
                                                        },
                                                        '& .super-app-theme--cell': {
                                                            color: '#00e676',
                                                            fontWeight: '600',
                                                        },
                                                    }}>
                                                        <DataGrid
                                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                            getRowId={(rows) => rows.codigo_Temporada}
                                                            rows={historicoLigaRows}
                                                            columns={columnsHistorico}

                                                            initialState={{
                                                                pagination: {
                                                                    paginationModel: {
                                                                        pageSize: 32,
                                                                        page: pagina,
                                                                    },
                                                                },
                                                            }}
                                                            pageSizeOptions={[32]}
                                                            // //checkboxSelection
                                                            disableRowSelectionOnClick
                                                            disableColumnFilter
                                                            disableColumnMenu
                                                            columnVisibilityModel={{ logo_Franquia: UtilidadeService.isMobile() ? false : true }}
                                                            sx={{
                                                                fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            )
                                                :
                                                <Grid  size={{xs:12, sm:12}} >
                                                    <Typography variant="h6">Não possui histórico de títulos</Typography>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <Grid container size={{xs:12, sm:12}}>
                                    <Grid container marginTop={1} size={{xs:12, sm:12}}>
                                        {!removeLoading && <Loading />}
                                        <Grid container size={{xs:12, sm:12}} padding={1}>
                                            <Grid  size={{xs:12, sm:12}} >
                                                <Typography variant="h6">CONFERÊNCIAS</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid  size={{xs:12, sm:12}} display="flex" textAlign="center" justifyContent="center" >
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}>
                                                    <span style={{ fontSize: UtilidadeService.isMobile() ? 12 : 19, fontWeight: "bold", }}>
                                                        {confrontosDetalhesConferencia?.nome_Primeira_Conferencia}
                                                    </span> {confrontosDetalhesConferencia?.quantidade_Titulo_Primeira_Conferencia} X {confrontosDetalhesConferencia?.quantidade_Titulo_Segunda_Conferencia}
                                                    <span style={{ fontSize: UtilidadeService.isMobile() ? 12 : 19, fontWeight: "bold", }}>
                                                        &nbsp;{confrontosDetalhesConferencia?.nome_Segunda_Conferencia}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12}} padding={1}>
                                                {historicoLigaRows.length > 0 && (
                                                    <Grid  size={{xs:12, sm:12}}>
                                                        <Box sx={{
                                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                            '& .super-app-theme--header': {
                                                                backgroundColor: theme.palette.common.black,
                                                                color: theme.palette.common.white
                                                            },
                                                            '& .super-app.negative': {
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            },
                                                            '& .super-app.positive': {
                                                                color: themeName === "light" ? "black" : "auto",
                                                            },
                                                            '& .super-app-theme--cell': {
                                                                color: '#00e676',
                                                                fontWeight: '600',
                                                            },
                                                        }}>
                                                            <DataGrid
                                                                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                getRowId={(rows) => rows.codigo_Temporada}
                                                                rows={listaConferencia}
                                                                columns={columnsDetalhesConfronto}

                                                                initialState={{
                                                                    pagination: {
                                                                        paginationModel: {
                                                                            pageSize: 32,
                                                                            page: pagina,
                                                                        },
                                                                    },
                                                                }}
                                                                pageSizeOptions={[32]}
                                                                // //checkboxSelection
                                                                disableRowSelectionOnClick
                                                                disableColumnFilter
                                                                disableColumnMenu
                                                                columnVisibilityModel={{codigo_Temporada: false, logo_Franquia: UtilidadeService.isMobile() ? false : true }}
                                                                sx={{
                                                                    fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                }}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid container size={{xs:12, sm:12}} padding={1}>
                                            <Grid container size={{xs:12, sm:12}} padding={1}>
                                                <Grid  size={{xs:12, sm:12}} >
                                                    <Typography variant="h6">DIVISÕES</Typography>
                                                    <hr />
                                                </Grid>
                                                {confrontosDetalhesDivisao.length > 0 && confrontosDetalhesDivisao.map((m, i) => (
                                                    <Grid container key={`grid${i}`} size={{xs:12, sm:12}} padding={2} >
                                                        <Grid container size={{xs:12, sm:12}} boxShadow={4} padding={2} spacing={2}>
                                                            <Grid size={{xs:4, sm:4}} >
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}>DIVISÃO: {m.nome}</Typography>
                                                            </Grid>
                                                            <Grid size={{xs:4, sm:4}} >
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}>LIGA: {m.quantidade_Titulo_Liga}</Typography>
                                                            </Grid>
                                                            <Grid size={{xs:4, sm:4}} >
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}>CONFERÊNCIA: {m.quantidade_Titulo_Conferencia}</Typography>
                                                            </Grid>
                                                              <Grid size={{xs:4, sm:4}} >
                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}>CONFERÊNCIA: {m.quantidade_Titulo_Copinha}</Typography>
                                                            </Grid>
                                                            <Grid size={{xs:12, sm:12}}>
                                                                <Box sx={{
                                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                                    '& .super-app-theme--header': {
                                                                        backgroundColor: theme.palette.common.black,
                                                                        color: theme.palette.common.white
                                                                    },
                                                                    '& .super-app.negative': {
                                                                        color: 'red',
                                                                        fontWeight: 'bold'
                                                                    },
                                                                    '& .super-app.positive': {
                                                                        color: themeName === "light" ? "black" : "auto",
                                                                    },
                                                                    '& .super-app-theme--cell': {
                                                                        color: '#00e676',
                                                                        fontWeight: '600',
                                                                    },
                                                                }}>
                                                                    <DataGrid
                                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                                        getRowId={(rows) => rows.posicao}
                                                                        rows={m.franquias_Divisao}
                                                                        columns={columnsGeral}

                                                                        initialState={{
                                                                            pagination: {
                                                                                paginationModel: {
                                                                                    pageSize: 32,
                                                                                    page: pagina,
                                                                                },
                                                                            },
                                                                        }}
                                                                        pageSizeOptions={[32]}
                                                                        // //checkboxSelection
                                                                        disableRowSelectionOnClick
                                                                        disableColumnFilter
                                                                        disableColumnMenu
                                                                        columnVisibilityModel={{
                                                                            logo_Franquia: UtilidadeService.isMobile() ? false : true,
                                                                            foto_Usuario: false,
                                                                            nome_Usuario: false,

                                                                        }}
                                                                        sx={{
                                                                            fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </TabPanel>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>

            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
        </LayoutBaseDePagina >
    );
};